export default "__VITE_ASSET__18a6e205__"